<template>
  <div class="modal fade" :id="id" tabindex="-1">
    <div class="modal-dialog">
      <form @submit.prevent="submitForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-name">{{!edit ? $t('categoryGroup.create') : $t('categoryGroup.update')}}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" 
                            fill="currentColor" />
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                  </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />

            <div class="row mb-8">
              <div class="col-12">
                <Input
                  container-class="form-group mb-5"
                  :name="`name`+id"
                  type="text"
                  :label="$t('categoryGroup.name')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  size="lg"
                  :isRequired="true" 
                  v-model="formData.name"
                />
              </div>
              <Select2
                  :parent-id="'#'+id"
                  :is-required="false"
                  container-class="col-12 mb-5"
                  :multiple="true"
                  :show-search="true"
                  :name="'category'+id"
                  :label="$t('categoryGroup.categories')"
                  label-class="form-label"
                  v-model="formData.project_category_id" 
              >
                  <option v-for="category in categories" :value="category?.id" :key="category?.id">
                      {{ category.name }}
                  </option>
              </Select2>
              
            </div>

          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
  import { ref, defineEmits, defineProps, watch, onMounted } from "vue";
  import Input from "@/components/Input.vue";
  import Button from "@/components/Button.vue";
  import RequiredText from "@/components/RequiredText.vue";
  import { useStore } from "vuex";
  import { computed } from "vue";
  import Select2 from "@/components/Select2.vue";

  const emits = defineEmits(["load", "statusCreated"]);

  const props = defineProps({
    id: {
      type: String,
      required: true,
    },
    parent: {
      type: String,
      required: false,
    },
    form: {
      type: Object,
      default: () => ({
        id: "",
        name: "",
        project_category_id: []
      }),
    },
    edit: {
      type: Boolean,
      default: false,
    },
  });

  const store = useStore();
  const isLoading = ref(false);
  const formData = ref({ ...props.form }); 

  const currentSociety = computed(() => store.getters['offices/getSelectedCompany'])
  const categories = computed(() => store.getters['projectCategories/getProjectCategories'])

  watch(
    () => props.form,
    (newForm) => {
      formData.value = { ...newForm };
    },
    { deep: true }
  );

  function closeModal() {
    if(props.parent){
      $("#" + props.parent).modal("toggle");
    }
    $("#" + props.id).modal("toggle");
    formData.value.name = "";
    formData.value.project_category_id = [];
  }

  function submitForm() {
    isLoading.value = true;
    if (!props.edit) {
      store
        .dispatch("projectCategories/storeCategoryGroup", {...formData.value, society_id: currentSociety?.value?.id})
        .then((resp) => {
          isLoading.value = false;
          emits("load");
          emits("categoryCreated", resp?.data?.data?.id)

          closeModal();
          
          window.toastr["success"](i18n.global.t("notification.category_group_created"));
        })
        .catch((e) => {
          isLoading.value = false;
        });
    } else {
      store
        .dispatch("projectCategories/updateCategoryGroup", {...formData.value, society_id: currentSociety?.value?.id})
        .then(() => {
          isLoading.value = false;
          emits("load");
          closeModal();

          window.toastr["success"](i18n.global.t("notification.category_group_updated"));
        })
        .catch(() => {
          isLoading.value = false;
        });
    }
  }

  onMounted(() => {
    store.dispatch("projectCategories/loadProjectCategories")
  })
</script>

<style scoped>
  .color-picker-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }
</style>
